<fd-user then="$ctrl.$isAdmin = $data.isAdmin"><then><fd-dispatcher fd-dispatcher-action="{
        type: 'SITE.UPDATE_PRODUCT',
        productId: $ctrl.productId,
        siteId: $ctrl.siteId,
        supplierId: $ctrl.supplierId,
        registration: $ctrl.registration,
        gallery: $ctrl.gallery,
        isAdmin: $ctrl.$isAdmin
      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error updating product registration"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Product registration updated succesfully"></wc-toast></then></fd-dispatcher></then></fd-user>